import type { CreateCustomer, Customer } from '../customer/customer.interface';
import { CUSTOMER_STATUS, CUSTOMER_TYPE } from '../customer/customer.interface';
import { GEOCODING_SOURCE } from '../geolocation';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class CustomerFactory extends ObjectFactory<Customer> {
  protected getDefaults(): Customer {
    return {
      ...baseDocumentFactory.build(),
      addresses: [
        {
          location: {
            address: {
              city: 'Paris',
              country: 'FR',
              postalCode: '75001',
              street: '1 Rue de la Paix',
            },
            coordinates: {
              latitude: 48.8566,
              longitude: 2.3522,
              score: 0.9,
              source: GEOCODING_SOURCE.KLAREO,
            },
          },
          originalAddress: '1 Rue de la Paix, 75001 Paris, FR',
        },
      ],
      firstName: 'John',
      lastName: 'Doe',
      phone: { dialCode: '+33', number: '612345678' },
      siteIds: ['aabbccddeeff001122334455'],
      spaceIds: ['bbbbbbbbbbbbbbbbbbbbbbbb'],
      status: CUSTOMER_STATUS.VALIDATED,
      type: CUSTOMER_TYPE.CLIENT,
    } as unknown as Customer;
  }

  /** Build a CreateCustomer body (no auto-generated fields). */
  buildCreate(overrides: Partial<CreateCustomer> = {}): CreateCustomer {
    return {
      addresses: [
        {
          location: {
            address: {
              city: 'Paris',
              country: 'FR',
              postalCode: '75001',
              street: '1 Rue de la Paix',
            },
            coordinates: {
              latitude: 48.8566,
              longitude: 2.3522,
              score: 0.9,
              source: GEOCODING_SOURCE.KLAREO,
            },
          },
          originalAddress: '1 Rue de la Paix, 75001 Paris, FR',
        },
      ],
      firstName: 'John',
      lastName: 'Doe',
      phone: { dialCode: '+33', number: '612345678' },
      siteIds: ['aabbccddeeff001122334455'],
      type: CUSTOMER_TYPE.CLIENT,
      ...overrides,
    };
  }
}

export const customerFactory = new CustomerFactory();
